import Keycloak from "keycloak-js";

const createKeycloakInstance = () => {
  // return new Keycloak({
  //   url: "http://localhost:4100/",
  //   realm: "edocSign-1",
  //   clientId: "Ourclient"
  // });
  return new Keycloak({
    url: "https://auth.leadnest.ai/",
    realm: "prod-leadnest-realm",
    clientId: "docusign-client",
    redirect_uri: "https://edocsign.leadnest.ai/"
  });
};

export default createKeycloakInstance;
